import { render, staticRenderFns } from "./CarHeadings.vue?vue&type=template&id=0e2bf294&"
import script from "./CarHeadings.vue?vue&type=script&lang=ts&"
export * from "./CarHeadings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports